<template>
  <div>
      <div class="page-title d-flex flex-column me-3 mt-3 mb-4"> 
      <h1 class="d-flex text-gray-800 fw-bolder my-1 fs-3">Home 
      </h1>  
      <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
          <li class="breadcrumb-item text-gray-600">
              <a href="#" class="text-gray-600 text-hover-primary">Welcome to CreatorCUBE !</a>
          </li>  
      </ul> 
  </div> 
  <div class="card mb-5 mb-xxl-8 mt-4 bgi-no-repeat bgi-position-y-top bgi-position-x-end shadow bg-abstract-1">
        <div class="card-body pt-7 pb-0">									
            <div class="d-flex flex-wrap flex-sm-nowrap">	 
                <div class="flex-grow-1">											
                    <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">												
                        <div class="d-flex flex-column">													
                            <div class="d-flex align-items-center mb-2"> 
                                <div class="symbol symbol-35px symbol-circle me-3">
                                    <img src="assets/theme/media/avatars/blank.png" />
                                </div>
                                <span class="text-gray-900 text-hover-primary fs-2 fw-bolder me-1">
                                        <span class="d-inline-block position-relative">
                                            <span class="d-inline-block mb-1 fs-2 fw-bold">
                                                  {{ userData.name_surname }}
                                            </span>
                                            <span class="d-inline-block position-absolute h-4px bottom-0 end-0 start-0 bg-primary translate rounded"></span>
                                        </span> 
                                    </span>   
                            </div>
                            <!-- <div class="d-flex align-items-center mb-2">
                                <span class="text-gray-900 text-hover-primary fs-5 me-1"><small></small></span>
                            </div> -->
                            <div class="separator separator-dashed mt-3 mb-6"></div>
                            <div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                                <span class="svg-icon svg-icon-4 me-7 text-hover-info"> 
                                    <span class="svg-icon svg-icon-info svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.302 11.35L12.002 20.55H21.202C21.802 20.55 22.202 19.85 21.902 19.35L17.302 11.35Z" fill="currentColor"/>
                                    <path opacity="0.3" d="M12.002 20.55H2.802C2.202 20.55 1.80202 19.85 2.10202 19.35L6.70203 11.45L12.002 20.55ZM11.302 3.45L6.70203 11.35H17.302L12.702 3.45C12.402 2.85 11.602 2.85 11.302 3.45Z" fill="currentColor"/>
                                    </svg>
                                    </span>
                                    {{ userData.controller_account_name }}
                                </span>
                                <span class="svg-icon svg-icon-4 me-7 text-hover-warning"> 
                                    <span class="svg-icon svg-icon-warning svg-icon-2"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"/>
                                    <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"/>
                                    <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"/>
                                    </svg>
                                    </span>
                                    {{ userData.user_mail }}
                                </span> 
                                <span class="d-flex align-items-center text-gray-400 text-hover-primary me-3 mb-2">	 
                                    <span class="badge badge-light-info fw-bolder fs-8 px-2 py-1" v-if="userData.account_type == 1">System</span>
                                    <span class="badge badge-light-primary fw-bolder fs-8 px-2 py-1" v-if="userData.account_type == 2">Controller</span>
                                    <span class="badge badge-light-danger fw-bolder fs-8 px-2 py-1" v-if="userData.account_type == 3">Company</span>
                                </span>
                                <span class="d-flex align-items-center text-gray-400 text-hover-primary mb-2">														
                                    <span class="badge badge-light-danger fw-bolder fs-8 px-2 py-1 ms-2" v-if="userData.permission_type == 1">Admin</span>
                                    <span class="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2" v-if="userData.permission_type == 2">Client</span> 
                                </span> 
                            </div> 
                        </div>   
                        <div class="d-flex align-items-end justify-content-end mb-2">
                            <div class="border border-dashed border-gray-300 rounded px-7 py-3 mb-6">
                                Session ID: <code>{{ userData.session_id }}</code>
                            </div>
                        </div> 
                    </div> 
                </div>
            </div> 								
        </div>
    </div> 
    <div class="row g-5 g-lg-10"> 
      <div class="col-xl-12 mb-xl-10" v-if="!this.$isSystemAdmin()">
        <div class="card shadow">
            <div class="card-header">
                <div class="card-title">
                  Your Companies
                </div>  
                <div class="card-toolbar"> 
                  <form class="d-flex align-items-center position-relative w-100 m-0" autocomplete="off">
                      <span class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"></rect>
                              <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"></path>
                          </svg>
                      </span>
                      <input type="text" data-kt-customer-table-filter="search" class="form-control form-control-solid w-300px ps-15" placeholder="Search company" v-model="searchbar">
                  </form>
                  </div>              
            </div> 
            <div class="card-body pt-0">
              <div class="table-responsive mh-550px ">
                <table id="kt_profile_overview_table" class="table table-row-bordered table-row-dashed table-hover gy-4">
                  <thead class="fs-7 text-gray-400 text-uppercase">
                    <tr>
                      <th class="text-gray-600">#</th>               
                      <th>Company Name</th>     
                      <th>Company Type</th>
                      <th>Country </th>
                      <th>Primary Person/Director </th>
                      <th>Controller Name</th>
                      <th class="text-end">Selection</th>
                      <th class="text-end">Actions</th>
                  </tr>
                  </thead>
                  <tbody class="fs-6">
                    <tr class="odd" v-for="(item, index) in searchableList" v-bind:key="item">
                      <td class="fs-7 text-gray-800"> {{index + 1}} </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="me-5 position-relative">
                            <div class="symbol symbol-35px symbol-circle">
                              <img alt="Pic" src="assets/theme/media/avatars/blank.png">
                            </div>
                          </div>
                          <div class="d-flex flex-column justify-content-center">
                            <a href="" class="fs-6 text-gray-800 text-hover-primary">{{item.text}}</a>
                            <div class="fw-semibold text-gray-400">{{item.company_vkn}}</div>
                          </div>
                        </div>
                      </td>
                      <td class="fs-7 text-gray-800">{{item.company_type_name}}</td>
                      <td class="fs-7 text-gray-800">{{item.company_country_code}}</td>
                      <td class="fs-7 text-gray-800">
                        {{item.primary_person}}
                      </td>
                      <td class="fs-7 text-gray-800"> {{item.controller_account_name }} </td>
                      <td>
                          <button type="button" class="btn btn-success border border-success btn-sm w-100px p-1 py-2" @click="onSelectCompany(item)">
                            <i class="bi bi-box-arrow-in-right"></i>
                            <span>Select</span>
                          </button>
                      </td>
                      <td>
                          <button v-if="item.instant_access == 1 && item.is_active == 1" type="button" class="btn btn-primary border border-primary btn-sm w-150px p-1 py-2" @click="onInstantLogin(item)" >
                            <i class="bi bi-box-arrow-right"></i>
                            <span>Instant Access</span>
                          </button>
                      </td>
                    </tr>
                    </tbody>
                </table>
              </div>
            </div>  
          </div>
      </div>
      <div class="col-xl-12 mb-xl-10" v-if="this.$isSystemAdmin()">
        <div class="card shadow">
            <div class="card-header">
                <div class="card-title">
                  Your Controllers
                </div>  
                <div class="card-toolbar"> 
                  <form class="d-flex align-items-center position-relative w-100 m-0" autocomplete="off">
                      <span class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor"></rect>
                              <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor"></path>
                          </svg>
                      </span>
                      <input type="text" data-kt-customer-table-filter="search" class="form-control form-control-solid w-300px ps-15" placeholder="Search controller" v-model="searchbar">
                  </form>
                </div>              
            </div> 
            <div class="card-body pt-0">
              <div class="table-responsive mh-550px ">
                <table id="kt_profile_overview_table" class="table table-row-bordered table-row-dashed table-hover gy-4 align-middle fw-bold dataTable no-footer">
                  <thead class="fs-7 text-gray-400 text-uppercase">
                    <tr>
                      <th class="text-gray-600">#</th>               
                      <th class="min-w-250px">Company Name</th>
                      <th class="min-w-90px">Country </th>
                      <th class="min-w-90px">City </th>
                      <th class="min-w-90px">Primary Person/Director </th>
                  </tr>
                  </thead>
                  <tbody class="fs-6">
                    <tr class="odd" v-for="(item, index) in searchableList" v-bind:key="item">
                      <td class="fs-7 text-gray-800"> {{index + 1}} </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="me-5 position-relative">
                            <div class="symbol symbol-35px symbol-circle">
                              <img alt="avatar" src="assets/theme/media/avatars/blank.png">
                            </div>
                          </div>
                          <div class="d-flex flex-column justify-content-center">
                            <a href="" class="fs-6 text-gray-800 text-hover-primary">{{item.text}}</a>
                            <div class="fw-semibold text-gray-400">{{item.company_vkn}}</div>
                          </div>
                        </div>
                      </td>
                      <td class="fs-7 text-gray-800">{{item.company_country_code}}</td>
                      <td class="fs-7 text-gray-800">{{item.company_city}}</td>
                      <td class="fs-7 text-gray-800">
                        {{item.primary_person}}
                      </td>
                    </tr>
                    </tbody>
                </table>
              </div>
            </div>  
          </div>
      </div> 
    </div> 
    <!-- <div class="row g-5 g-lg-10">
      <div class="col-xxl-4 col-md-4 mb-xxl-10">
        <div class="card h-md-100">
          <div class="card-header align-items-center border-0 mt-4">
            <h3 class="card-title align-items-start flex-column">
              <span class="fw-bolder mb-2 text-gray-800">Activities</span>
              <span class="text-muted fw-bold fs-7">890,344 Sales</span>
            </h3>
            <div class="card-toolbar">
              <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" 
              data-kt-menu-trigger="click" 
              data-kt-menu-placement="bottom-end">
                <span class="svg-icon svg-icon-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" >
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect x="5" y="5" width="5" height="5" rx="1" fill="currentColor"/>
                      <rect x="14" y="5" width="5" height="5" rx="1" fill="currentColor" opacity="0.3"/>
                      <rect x="5" y="14" width="5" height="5" rx="1" fill="currentColor" opacity="0.3" />
                      <rect x="14" y="14" width="5" height="5" rx="1" fill="currentColor" opacity="0.3"/>
                    </g>
                  </svg>
                </span>
              </button>
              <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true" id="kt_menu_62444f9137182">
                <div class="px-7 py-5">
                  <div class="fs-5 text-gray-800 fw-bolder">Filter Options</div>
                </div>
                <div class="separator border-gray-200"></div>
                <div class="px-7 py-5">
                  <div class="mb-10">
                    <label class="form-label fw-bold">
                      Status:
                    </label>
                    <div>
                      <select class="form-select form-select-solid"
                        data-kt-select2="true"
                        data-placeholder="Select option"
                        data-dropdown-parent="#kt_menu_62444f9137182"
                        data-allow-clear="true">
                        <option></option>
                        <option value="1">Approved</option>
                        <option value="2">Pending</option>
                        <option value="2">In Process</option>
                        <option value="2">Rejected</option>
                      </select>
                    </div>
                  </div>
                  <div class="mb-10">
                    <label class="form-label fw-bold">Member Type:</label>
                    <div class="d-flex">
                      <label class=" form-check form-check-sm form-check-custom form-check-solid me-5 ">
                        <input class="form-check-input" type="checkbox" value="1"/>
                        <span class="form-check-label">Author</span>
                      </label>
                      <label class=" form-check form-check-sm form-check-custom form-check-solid">
                        <input class="form-check-input" type="checkbox" value="2" checked="checked" />
                        <span class="form-check-label">Customer</span>
                      </label>
                    </div>
                  </div>
                  <div class="mb-10">
                    <label class="form-label fw-bold">Notifications:</label>
                    <div class=" form-check form-switch form-switch-sm form-check-custom form-check-solid">
                      <input class="form-check-input" type="checkbox" value="" name="notifications" checked="checked"/>
                      <label class="form-check-label">Enabled</label>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <button
                      type="reset"
                      class="btn btn-sm btn-light btn-active-light-primary me-2"
                      data-kt-menu-dismiss="true"
                    >
                      Reset
                    </button>
                    <button
                      type="submit"
                      class="btn btn-sm btn-primary"
                      data-kt-menu-dismiss="true"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body pt-5">
            <div class="timeline-label">
              <div class="timeline-item">
                <div class="timeline-label fw-bolder text-gray-800 fs-6">
                  08:42
                </div>

                <div class="timeline-badge">
                  <i class="fa fa-genderless text-warning fs-1"></i>
                </div>

                <div class="fw-mormal timeline-content text-muted ps-3">
                  Outlines keep you honest. And keep structure
                </div>
              </div>

              <div class="timeline-item">
                <div class="timeline-label fw-bolder text-gray-800 fs-6">
                  10:00
                </div>

                <div class="timeline-badge">
                  <i class="fa fa-genderless text-success fs-1"></i>
                </div>

                <div class="timeline-content d-flex">
                  <span class="fw-bolder text-gray-800 ps-3">AEOL meeting</span>
                </div>
              </div>

              <div class="timeline-item">
                <div class="timeline-label fw-bolder text-gray-800 fs-6">
                  14:37
                </div>

                <div class="timeline-badge">
                  <i class="fa fa-genderless text-danger fs-1"></i>
                </div>

                <div class="timeline-content fw-bolder text-gray-800 ps-3">
                  Make deposit <a href="#" class="text-primary">USD 700</a>. to
                  ESL
                </div>
              </div>

              <div class="timeline-item">
                <div class="timeline-label fw-bolder text-gray-800 fs-6">
                  16:50
                </div>

                <div class="timeline-badge">
                  <i class="fa fa-genderless text-primary fs-1"></i>
                </div>

                <div class="timeline-content fw-mormal text-muted ps-3">
                  Indulging in poorly driving and keep structure keep great
                </div>
              </div>

              <div class="timeline-item">
                <div class="timeline-label fw-bolder text-gray-800 fs-6">
                  21:03
                </div>

                <div class="timeline-badge">
                  <i class="fa fa-genderless text-danger fs-1"></i>
                </div>

                <div class="timeline-content fw-bold text-gray-800 ps-3">
                  New order placed
                  <a href="#" class="text-primary">#XF-2356</a>.
                </div>
              </div>

              <div class="timeline-item">
                <div class="timeline-label fw-bolder text-gray-800 fs-6">
                  16:50
                </div>

                <div class="timeline-badge">
                  <i class="fa fa-genderless text-primary fs-1"></i>
                </div>

                <div class="timeline-content fw-mormal text-muted ps-3">
                  Indulging in poorly driving and keep structure keep great
                </div>
              </div>

              <div class="timeline-item">
                <div class="timeline-label fw-bolder text-gray-800 fs-6">
                  21:03
                </div>

                <div class="timeline-badge">
                  <i class="fa fa-genderless text-danger fs-1"></i>
                </div>

                <div class="timeline-content fw-bold text-gray-800 ps-3">
                  New order placed
                  <a href="#" class="text-primary">#XF-2356</a>.
                </div>
              </div>

              <div class="timeline-item mb-9">
                <div class="timeline-label fw-bolder text-gray-800 fs-6">
                  10:30
                </div>

                <div class="timeline-badge">
                  <i class="fa fa-genderless text-success fs-1"></i>
                </div>

                <div class="timeline-content fw-mormal text-muted ps-3">
                  Finance KPI Mobile app launch preparion meeting
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xxl-4 col-md-4 mb-xxl-10">
        <div class="card h-md-100">
          <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bolder fs-3 mb-1">
                Sales Statistics
                </span>
              <span class="text-muted fw-bold fs-7">
                Recent sales statistics
                </span>
            </h3>
            <div class="card-toolbar">
              <button type="button" class="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end">
                <span class="svg-icon svg-icon-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect x="5" y="5" width="5" height="5"  rx="1" fill="currentColor"/>
                      <rect x="14" y="5" width="5" height="5" rx="1" fill="currentColor" opacity="0.3"/>
                      <rect x="5" y="14" width="5" height="5" rx="1" fill="currentColor" opacity="0.3"/>
                      <rect x="14" y="14" width="5" height="5" rx="1" fill="currentColor" opacity="0.3"/>
                    </g>
                  </svg>
                </span>
              </button>

              <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px"
                data-kt-menu="true" id="kt_menu_62444f9137a9d">
                <div class="px-7 py-5">
                  <div class="fs-5 text-gray-800 fw-bolder">Filter Options</div>
                </div>

                <div class="separator border-gray-200"></div>

                <div class="px-7 py-5">
                  <div class="mb-10">
                    <label class="form-label fw-bold">Status:</label>

                    <div>
                      <select class="form-select form-select-solid"
                        data-kt-select2="true"
                        data-placeholder="Select option"
                        data-dropdown-parent="#kt_menu_62444f9137a9d"
                        data-allow-clear="true">
                        <option></option>
                        <option value="1">Approved</option>
                        <option value="2">Pending</option>
                        <option value="2">In Process</option>
                        <option value="2">Rejected</option>
                      </select>
                    </div>
                  </div>

                  <div class="mb-10">
                    <label class="form-label fw-bold">Member Type:</label>

                    <div class="d-flex">
                      <label class=" form-check form-check-sm form-check-custom form-check-solid me-5 ">
                        <input class="form-check-input" type="checkbox" value="1" />
                        <span class="form-check-label">Author</span>
                      </label>

                      <label class=" form-check form-check-sm form-check-custom form-check-solid">
                        <input class="form-check-input" type="checkbox" value="2" checked="checked"/>
                        <span class="form-check-label">Customer</span>
                      </label>
                    </div>
                  </div>

                  <div class="mb-10">
                    <label class="form-label fw-bold">Notifications:</label>

                    <div class=" form-check form-switch form-switch-sm form-check-custom form-check-solid">
                      <input class="form-check-input" type="checkbox" value="" name="notifications" checked="checked"/>
                      <label class="form-check-label">Enabled</label>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end">
                    <button type="reset" class="btn btn-sm btn-light btn-active-light-primary me-2"
                    data-kt-menu-dismiss="true">
                      Reset
                    </button>
                    <button type="submit" class="btn btn-sm btn-primary"
                      data-kt-menu-dismiss="true">
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body p-0 d-flex flex-column">
            <div class="card-px pt-5 pb-10 flex-grow-1">
              <div class="row g-0 mt-5 mb-10">
                <div class="col">
                  <div class="d-flex align-items-center me-2">
                    <div class="symbol symbol-50px me-3">
                      <div class="symbol-label bg-light-info">
                        <span class="svg-icon svg-icon-1 svg-icon-info">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M20.859 12.596L17.736 13.596L10.388 20.944C10.2915 21.0406 10.1769 21.1172 10.0508 21.1695C9.9247 21.2218 9.78953 21.2486 9.65302 21.2486C9.5165 21.2486 9.3813 21.2218 9.25519 21.1695C9.12907 21.1172 9.01449 21.0406 8.918 20.944L2.29999 14.3229C2.10543 14.1278 1.99619 13.8635 1.99619 13.588C1.99619 13.3124 2.10543 13.0481 2.29999 12.853L11.853 3.29999C11.9495 3.20341 12.0641 3.12679 12.1902 3.07452C12.3163 3.02225 12.4515 2.9953 12.588 2.9953C12.7245 2.9953 12.8597 3.02225 12.9858 3.07452C13.1119 3.12679 13.2265 3.20341 13.323 3.29999L21.199 11.176C21.3036 11.2791 21.3797 11.4075 21.4201 11.5486C21.4605 11.6898 21.4637 11.8391 21.4295 11.9819C21.3953 12.1247 21.3249 12.2562 21.2249 12.3638C21.125 12.4714 20.9989 12.5514 20.859 12.596Z" fill="currentColor"/>
                            <path d="M14.8 10.184C14.7447 10.1843 14.6895 10.1796 14.635 10.1699L5.816 8.69997C5.55436 8.65634 5.32077 8.51055 5.16661 8.29469C5.01246 8.07884 4.95035 7.8106 4.99397 7.54897C5.0376 7.28733 5.18339 7.05371 5.39925 6.89955C5.6151 6.7454 5.88334 6.68332 6.14498 6.72694L14.963 8.19692C15.2112 8.23733 15.435 8.36982 15.59 8.56789C15.7449 8.76596 15.8195 9.01502 15.7989 9.26564C15.7784 9.51626 15.6642 9.75001 15.479 9.92018C15.2939 10.0904 15.0514 10.1846 14.8 10.184ZM17 18.6229C17 19.0281 17.0985 19.4272 17.287 19.7859C17.4755 20.1446 17.7484 20.4521 18.0821 20.6819C18.4158 20.9117 18.8004 21.0571 19.2027 21.1052C19.605 21.1534 20.0131 21.103 20.3916 20.9585C20.7702 20.814 21.1079 20.5797 21.3758 20.2757C21.6437 19.9716 21.8336 19.607 21.9293 19.2133C22.025 18.8195 22.0235 18.4085 21.925 18.0154C21.8266 17.6223 21.634 17.259 21.364 16.9569L19.843 15.257C19.7999 15.2085 19.7471 15.1697 19.688 15.1432C19.6289 15.1167 19.5648 15.1029 19.5 15.1029C19.4352 15.1029 19.3711 15.1167 19.312 15.1432C19.2529 15.1697 19.2001 15.2085 19.157 15.257L17.636 16.9569C17.2254 17.4146 16.9988 18.0081 17 18.6229ZM10.388 20.9409L17.736 13.5929H1.99999C1.99921 13.7291 2.02532 13.8643 2.0768 13.9904C2.12828 14.1165 2.2041 14.2311 2.29997 14.3279L8.91399 20.9409C9.01055 21.0381 9.12539 21.1152 9.25188 21.1679C9.37836 21.2205 9.51399 21.2476 9.65099 21.2476C9.78798 21.2476 9.92361 21.2205 10.0501 21.1679C10.1766 21.1152 10.2914 21.0381 10.388 20.9409Z" fill="currentColor"/>
                          </svg>
                        </span>
                      </div>
                    </div>

                    <div>
                      <div class="fs-4 text-gray-800 fw-bolder">$2,034</div>
                      <div class="fs-7 text-muted fw-bold">Author Sales</div>
                    </div>
                  </div>
                </div>

                <div class="col">
                  <div class="d-flex align-items-center me-2">
                    <div class="symbol symbol-50px me-3">
                      <div class="symbol-label bg-light-danger">
                        <span class="svg-icon svg-icon-1 svg-icon-danger">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z" fill="currentColor"/>
                            <path d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z" fill="currentColor"/>
                          </svg>
                        </span>
                      </div>
                    </div>

                    <div>
                      <div class="fs-4 text-gray-800 fw-bolder">$706</div>
                      <div class="fs-7 text-muted fw-bold">Commision</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row g-0">
                <div class="col">
                  <div class="d-flex align-items-center me-2">
                    <div class="symbol symbol-50px me-3">
                      <div class="symbol-label bg-light-success">
                        <span class="svg-icon svg-icon-1 svg-icon-success">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M21 10H13V11C13 11.6 12.6 12 12 12C11.4 12 11 11.6 11 11V10H3C2.4 10 2 10.4 2 11V13H22V11C22 10.4 21.6 10 21 10Z" fill="currentColor"/>
                            <path opacity="0.3" d="M12 12C11.4 12 11 11.6 11 11V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V11C13 11.6 12.6 12 12 12Z" fill="currentColor"/>
                            <path opacity="0.3" d="M18.1 21H5.9C5.4 21 4.9 20.6 4.8 20.1L3 13H21L19.2 20.1C19.1 20.6 18.6 21 18.1 21ZM13 18V15C13 14.4 12.6 14 12 14C11.4 14 11 14.4 11 15V18C11 18.6 11.4 19 12 19C12.6 19 13 18.6 13 18ZM17 18V15C17 14.4 16.6 14 16 14C15.4 14 15 14.4 15 15V18C15 18.6 15.4 19 16 19C16.6 19 17 18.6 17 18ZM9 18V15C9 14.4 8.6 14 8 14C7.4 14 7 14.4 7 15V18C7 18.6 7.4 19 8 19C8.6 19 9 18.6 9 18Z" fill="currentColor"/>
                          </svg>
                        </span>
                      </div>
                    </div>

                    <div>
                      <div class="fs-4 text-gray-800 fw-bolder">$49</div>
                      <div class="fs-7 text-muted fw-bold">Average Bid</div>
                    </div>
                  </div>
                </div>

                <div class="col">
                  <div class="d-flex align-items-center me-2">
                    <div class="symbol symbol-50px me-3">
                      <div class="symbol-label bg-light-primary">
                        <span class="svg-icon svg-icon-1 svg-icon-primary">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M3 6C2.4 6 2 5.6 2 5V3C2 2.4 2.4 2 3 2H5C5.6 2 6 2.4 6 3C6 3.6 5.6 4 5 4H4V5C4 5.6 3.6 6 3 6ZM22 5V3C22 2.4 21.6 2 21 2H19C18.4 2 18 2.4 18 3C18 3.6 18.4 4 19 4H20V5C20 5.6 20.4 6 21 6C21.6 6 22 5.6 22 5ZM6 21C6 20.4 5.6 20 5 20H4V19C4 18.4 3.6 18 3 18C2.4 18 2 18.4 2 19V21C2 21.6 2.4 22 3 22H5C5.6 22 6 21.6 6 21ZM22 21V19C22 18.4 21.6 18 21 18C20.4 18 20 18.4 20 19V20H19C18.4 20 18 20.4 18 21C18 21.6 18.4 22 19 22H21C21.6 22 22 21.6 22 21Z" fill="currentColor"/>
                            <path d="M3 16C2.4 16 2 15.6 2 15V9C2 8.4 2.4 8 3 8C3.6 8 4 8.4 4 9V15C4 15.6 3.6 16 3 16ZM13 15V9C13 8.4 12.6 8 12 8C11.4 8 11 8.4 11 9V15C11 15.6 11.4 16 12 16C12.6 16 13 15.6 13 15ZM17 15V9C17 8.4 16.6 8 16 8C15.4 8 15 8.4 15 9V15C15 15.6 15.4 16 16 16C16.6 16 17 15.6 17 15ZM9 15V9C9 8.4 8.6 8 8 8H7C6.4 8 6 8.4 6 9V15C6 15.6 6.4 16 7 16H8C8.6 16 9 15.6 9 15ZM22 15V9C22 8.4 21.6 8 21 8H20C19.4 8 19 8.4 19 9V15C19 15.6 19.4 16 20 16H21C21.6 16 22 15.6 22 15Z" fill="currentColor"/>
                          </svg>
                        </span>
                      </div>
                    </div>

                    <div>
                      <div class="fs-4 text-gray-800 fw-bolder">$5.8M</div>
                      <div class="fs-7 text-muted fw-bold">All Time Sales</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mixed-widget-6-chart card-rounded-bottom"
              data-kt-chart-color="danger" style="height: 150px">
            </div>
          </div>
        </div>
      </div>

      <div class="col-xxl-4 col-md-4 mb-xxl-10">
        <div class="card h-md-100">
          <div class="card-body p-0">
            <div class="px-9 pt-7 card-rounded h-275px w-100 bg-primary">
              <div class="d-flex flex-stack">
                <h3 class="m-0 text-white fw-bolder fs-3">Sales Summary</h3>
                <div class="ms-1">
                  <button type="button" class=" btn btn-sm btn-icon btn-color-white btn-active-white btn-active-color-primary border-0 me-n3" 
                  data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-end">
                    <span class="svg-icon svg-icon-2">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <rect x="5" y="5" width="5" height="5" rx="1" fill="currentColor"/>
                          <rect x="14" y="5" width="5" height="5" rx="1" fill="currentColor" opacity="0.3"/>
                          <rect x="5" y="14" width="5" height="5" rx="1" fill="currentColor" opacity="0.3"/>
                          <rect x="14" y="14" width="5" height="5" rx="1" fill="currentColor" opacity="0.3"/>
                        </g>
                      </svg>
                    </span>
                  </button>

                  <div class=" menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3"
                  data-kt-menu="true">
                    <div class="menu-item px-3">
                      <div class=" menu-content text-muted pb-2 px-3 fs-7 text-uppercase">
                        Payments
                      </div>
                    </div>

                    <div class="menu-item px-3">
                      <a href="#" class="menu-link px-3">Create Invoice</a>
                    </div>

                    <div class="menu-item px-3">
                      <a href="#" class="menu-link flex-stack px-3">
                        Create Payment
                        <i class="fas fa-exclamation-circle ms-2 fs-7"
                          data-bs-toggle="tooltip" title="Specify a target name for future usage and reference">
                        </i>
                        </a>
                    </div>

                    <div class="menu-item px-3">
                      <a href="#" class="menu-link px-3">Generate Bill</a>
                    </div>

                    <div class="menu-item px-3"
                      data-kt-menu-trigger="hover"
                      data-kt-menu-placement="right-end">
                      <a href="#" class="menu-link px-3">
                        <span class="menu-title">Subscription</span>
                        <span class="menu-arrow"></span>
                      </a>

                      <div class="menu-sub menu-sub-dropdown w-175px py-4">
                        <div class="menu-item px-3">
                          <a href="#" class="menu-link px-3">Plans</a>
                        </div>

                        <div class="menu-item px-3">
                          <a href="#" class="menu-link px-3">Billing</a>
                        </div>

                        <div class="menu-item px-3">
                          <a href="#" class="menu-link px-3">Statements</a>
                        </div>

                        <div class="separator my-2"></div>

                        <div class="menu-item px-3">
                          <div class="menu-content px-3">
                            <label class=" form-check form-switch form-check-custom form-check-solid">
                              <input class="form-check-input w-30px h-20px" type="checkbox" value="1" checked="checked" name="notifications"/>

                              <span class="form-check-label text-muted fs-6">
                                Recuring
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="menu-item px-3 my-1">
                      <a href="#" class="menu-link px-3">Settings</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex text-center flex-column text-white pt-8">
                <span class="fw-bold fs-7">You Balance</span>
                <span class="fw-bolder fs-2x pt-1">$37,562.00</span>
              </div>
            </div>

            <div class=" bg-body shadow-sm card-rounded mx-9 mb-9 px-6 py-9 position-relative z-index-1" style="margin-top: -100px">
              <div class="d-flex align-items-center mb-6">
                <div class="symbol symbol-45px w-40px me-5">
                  <span class="symbol-label bg-lighten">
                    <span class="svg-icon svg-icon-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path opacity="0.3" d="M18.4 5.59998C21.9 9.09998 21.9 14.8 18.4 18.3C14.9 21.8 9.2 21.8 5.7 18.3L18.4 5.59998Z" fill="currentColor"/>
                        <path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM19.9 11H13V8.8999C14.9 8.6999 16.7 8.00005 18.1 6.80005C19.1 8.00005 19.7 9.4 19.9 11ZM11 19.8999C9.7 19.6999 8.39999 19.2 7.39999 18.5C8.49999 17.7 9.7 17.2001 11 17.1001V19.8999ZM5.89999 6.90002C7.39999 8.10002 9.2 8.8 11 9V11.1001H4.10001C4.30001 9.4001 4.89999 8.00002 5.89999 6.90002ZM7.39999 5.5C8.49999 4.7 9.7 4.19998 11 4.09998V7C9.7 6.8 8.39999 6.3 7.39999 5.5ZM13 17.1001C14.3 17.3001 15.6 17.8 16.6 18.5C15.5 19.3 14.3 19.7999 13 19.8999V17.1001ZM13 4.09998C14.3 4.29998 15.6 4.8 16.6 5.5C15.5 6.3 14.3 6.80002 13 6.90002V4.09998ZM4.10001 13H11V15.1001C9.1 15.3001 7.29999 16 5.89999 17.2C4.89999 16 4.30001 14.6 4.10001 13ZM18.1 17.1001C16.6 15.9001 14.8 15.2 13 15V12.8999H19.9C19.7 14.5999 19.1 16.0001 18.1 17.1001Z" fill="currentColor"/>
                      </svg>
                    </span>
                  </span>
                </div>

                <div class="d-flex align-items-center flex-wrap w-100">
                  <div class="mb-1 pe-3 flex-grow-1">
                    <a href="#" class="fs-5 text-gray-800 text-hover-primary fw-bolder">
                      Sales
                    </a>
                    <div class="text-gray-400 fw-bold fs-7">100 Regions</div>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="fw-bolder fs-5 text-gray-800 pe-1">$2,5b</div>

                    <span class="svg-icon svg-icon-5 svg-icon-success ms-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="13" y="6" width="13" height="2" rx="1" transform="rotate(90 13 6)" fill="currentColor"/>
                        <path d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z" fill="currentColor"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center mb-6">
                <div class="symbol symbol-45px w-40px me-5">
                  <span class="symbol-label bg-lighten">
                    <span class="svg-icon svg-icon-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="2" y="2" width="9" height="9" rx="2" fill="currentColor"/>
                        <rect opacity="0.3" x="13" y="2" width="9" height="9" rx="2" fill="currentColor"/>
                        <rect opacity="0.3" x="13" y="13" width="9" height="9" rx="2" fill="currentColor"/>
                        <rect opacity="0.3" x="2" y="13" width="9" height="9" rx="2" fill="currentColor"/>
                      </svg>
                    </span>
                  </span>
                </div>

                <div class="d-flex align-items-center flex-wrap w-100">
                  <div class="mb-1 pe-3 flex-grow-1">
                    <a href="#" class="fs-5 text-gray-800 text-hover-primary fw-bolder">
                      Revenue
                    </a>
                    <div class="text-gray-400 fw-bold fs-7">Quarter 2/3</div>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="fw-bolder fs-5 text-gray-800 pe-1">$1,7b</div>

                    <span class="svg-icon svg-icon-5 svg-icon-danger ms-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="11" y="18" width="13" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"/>
                        <path d="M11.4343 15.4343L7.25 11.25C6.83579 10.8358 6.16421 10.8358 5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75L11.2929 18.2929C11.6834 18.6834 12.3166 18.6834 12.7071 18.2929L18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25C17.8358 10.8358 17.1642 10.8358 16.75 11.25L12.5657 15.4343C12.2533 15.7467 11.7467 15.7467 11.4343 15.4343Z" fill="currentColor"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center mb-6">
                <div class="symbol symbol-45px w-40px me-5">
                  <span class="symbol-label bg-lighten">
                    <span class="svg-icon svg-icon-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path opacity="0.3" d="M15 19H7C5.9 19 5 18.1 5 17V7C5 5.9 5.9 5 7 5H15C16.1 5 17 5.9 17 7V17C17 18.1 16.1 19 15 19Z" fill="currentColor"/>
                        <path d="M8.5 2H13.4C14 2 14.5 2.4 14.6 3L14.9 5H6.89999L7.2 3C7.4 2.4 7.9 2 8.5 2ZM7.3 21C7.4 21.6 7.9 22 8.5 22H13.4C14 22 14.5 21.6 14.6 21L14.9 19H6.89999L7.3 21ZM18.3 10.2C18.5 9.39995 18.5 8.49995 18.3 7.69995C18.2 7.29995 17.8 6.90002 17.3 6.90002H17V10.9H17.3C17.8 11 18.2 10.7 18.3 10.2Z" fill="currentColor"/>
                      </svg>
                    </span>
                  </span>
                </div>

                <div class="d-flex align-items-center flex-wrap w-100">
                  <div class="mb-1 pe-3 flex-grow-1">
                    <a href="#" class="fs-5 text-gray-800 text-hover-primary fw-bolder">
                      Growth
                      </a>
                    <div class="text-gray-400 fw-bold fs-7">80% Rate</div>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="fw-bolder fs-5 text-gray-800 pe-1">$8,8m</div>

                    <span class="svg-icon svg-icon-5 svg-icon-success ms-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="13" y="6" width="13" height="2" rx="1" transform="rotate(90 13 6)" fill="currentColor"/>
                        <path d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z" fill="currentColor"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>

              <div class="d-flex align-items-center">
                <div class="symbol symbol-45px w-40px me-5">
                  <span class="symbol-label bg-lighten">
                    <span class="svg-icon svg-icon-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path opacity="0.3" d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM12.5 18C12.5 17.4 12.6 17.5 12 17.5H8.5C7.9 17.5 8 17.4 8 18C8 18.6 7.9 18.5 8.5 18.5L12 18C12.6 18 12.5 18.6 12.5 18ZM16.5 13C16.5 12.4 16.6 12.5 16 12.5H8.5C7.9 12.5 8 12.4 8 13C8 13.6 7.9 13.5 8.5 13.5H15.5C16.1 13.5 16.5 13.6 16.5 13ZM12.5 8C12.5 7.4 12.6 7.5 12 7.5H8C7.4 7.5 7.5 7.4 7.5 8C7.5 8.6 7.4 8.5 8 8.5H12C12.6 8.5 12.5 8.6 12.5 8Z" fill="currentColor"/>
                        <rect x="7" y="17" width="6" height="2" rx="1" fill="currentColor"/>
                        <rect x="7" y="12" width="10" height="2" rx="1" fill="currentColor"/>
                        <rect x="7" y="7" width="6" height="2" rx="1" fill="currentColor"/>
                        <path d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z" fill="currentColor"/>
                      </svg>
                    </span>
                  </span>
                </div>

                <div class="d-flex align-items-center flex-wrap w-100">
                  <div class="mb-1 pe-3 flex-grow-1">
                    <a href="#" class="fs-5 text-gray-800 text-hover-primary fw-bolder">
                      Dispute
                    </a>
                    <div class="text-gray-400 fw-bold fs-7">3090 Refunds</div>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="fw-bolder fs-5 text-gray-800 pe-1">$270m</div>

                    <span class="svg-icon svg-icon-5 svg-icon-danger ms-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="11" y="18" width="13" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"/>
                        <path d="M11.4343 15.4343L7.25 11.25C6.83579 10.8358 6.16421 10.8358 5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75L11.2929 18.2929C11.6834 18.6834 12.3166 18.6834 12.7071 18.2929L18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25C17.8358 10.8358 17.1642 10.8358 16.75 11.25L12.5657 15.4343C12.2533 15.7467 11.7467 15.7467 11.4343 15.4343Z" fill="currentColor"/>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>   
    <div class="modal fade" id="kt_modal_add_event" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog modal-dialog-centered mw-650px">
        <div class="modal-content">
          <form class="form" action="#" id="kt_modal_add_event_form">
            <div class="modal-header">
              <h2 class="fw-bolder" 
              data-kt-calendar="title">Add Event</h2>

              <div class="btn btn-icon btn-sm btn-active-icon-primary" id="kt_modal_add_event_close">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"/>
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"/>
                  </svg>
                </span>
              </div>
            </div>

            <div class="modal-body py-10 px-lg-17">
              <div class="fv-row mb-9">
                <label class="fs-6 fw-bold mb-2 required">Event Name</label>
                <input type="text" class="form-control form-control-solid" placeholder="" name="calendar_event_name"/>
              </div>

              <div class="fv-row mb-9">
                <label class="fs-6 fw-bold mb-2">Event Description</label>

                <input type="text" class="form-control form-control-solid" placeholder="" name="calendar_event_description"/>
              </div>

              <div class="fv-row mb-9">
                <label class="fs-6 fw-bold mb-2">Event Location</label>

                <input type="text" class="form-control form-control-solid" placeholder="" name="calendar_event_location"/>
              </div>

              <div class="fv-row mb-9">
                <label class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" value="" id="kt_calendar_datepicker_allday"/>
                  <span class="form-check-label fw-bold" for="kt_calendar_datepicker_allday">
                    All Day
                  </span>
                </label>
              </div>

              <div class="row row-cols-lg-2 g-10">
                <div class="col">
                  <div class="fv-row mb-9">
                    <label class="fs-6 fw-bold mb-2 required">
                      Event Start Date
                    </label>

                    <input class="form-control form-control-solid" name="calendar_event_start_date" placeholder="Pick a start date" id="kt_calendar_datepicker_start_date"/>
                  </div>
                </div>
                <div class="col" data-kt-calendar="datepicker">
                  <div class="fv-row mb-9">
                    <label class="fs-6 fw-bold mb-2">Event Start Time</label>

                    <input class="form-control form-control-solid" name="calendar_event_start_time" placeholder="Pick a start time" id="kt_calendar_datepicker_start_time"/>
                  </div>
                </div>
              </div>

              <div class="row row-cols-lg-2 g-10">
                <div class="col">
                  <div class="fv-row mb-9">
                    <label class="fs-6 fw-bold mb-2 required">
                      Event End Date
                    </label>

                    <input class="form-control form-control-solid" name="calendar_event_end_date" placeholder="Pick a end date" id="kt_calendar_datepicker_end_date"/>
                  </div>
                </div>
                <div class="col" data-kt-calendar="datepicker">
                  <div class="fv-row mb-9">
                    <label class="fs-6 fw-bold mb-2">Event End Time</label>

                    <input class="form-control form-control-solid" name="calendar_event_end_time" placeholder="Pick a end time" id="kt_calendar_datepicker_end_time"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer flex-center">
              <button type="reset" id="kt_modal_add_event_cancel" class="btn btn-light me-3">
                Cancel
              </button>

              <button type="button" id="kt_modal_add_event_submit" class="btn btn-primary">
                <span class="indicator-label">Submit</span>
                <span class="indicator-progress">
                  Please wait...
                  <span class="spinner-border spinner-border-sm align-middle ms-2">
                  </span>
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div> 
    <div class="modal fade" id="kt_modal_view_event" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog modal-dialog-centered mw-650px">
        <div class="modal-content">
          <div class="modal-header border-0 justify-content-end">
            <div class=" btn btn-icon btn-sm btn-color-gray-400 btn-active-icon-primary me-2"
              data-bs-toggle="tooltip"
              data-bs-dismiss="click" title="Edit Event" id="kt_modal_view_event_edit">
              <span class="svg-icon svg-icon-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"/>
                  <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"/>
                </svg>
              </span>
            </div>

            <div class=" btn btn-icon btn-sm btn-color-gray-400 btn-active-icon-danger me-2"
              data-bs-toggle="tooltip"
              data-bs-dismiss="click" title="Delete Event" id="kt_modal_view_event_delete">
              <span class="svg-icon svg-icon-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor" />
                  <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"/>
                  <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"/>
                </svg>
              </span>
            </div>

            <div class=" btn btn-icon btn-sm btn-color-gray-500 btn-active-icon-primary "
              data-bs-toggle="tooltip" title="Hide Event"
              data-bs-dismiss="modal">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>

          <div class="modal-body pt-0 pb-20 px-lg-17">
            <div class="d-flex">
              <span class="svg-icon svg-icon-1 svg-icon-muted me-5">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="currentColor"/>
                  <path d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z" fill="currentColor"/>
                  <path d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z" fill="currentColor"/>
                </svg>
              </span>

              <div class="mb-9">
                <div class="d-flex align-items-center mb-2">
                  <span class="fs-3 fw-bolder me-3"
                     data-kt-calendar="event_name">
                    </span>
                  <span class="badge badge-light-success" 
                     data-kt-calendar="all_day">
                    </span>
                </div>

                <div class="fs-6" data-kt-calendar="event_description">
                </div>
              </div>
            </div>

            <div class="d-flex align-items-center mb-2">
              <span class="svg-icon svg-icon-1 svg-icon-success me-5">
                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                  <circle fill="currentColor" cx="12" cy="12" r="8"/>
                </svg>
              </span>

              <div class="fs-6">
                <span class="fw-bolder">Starts</span>
                <span data-kt-calendar="event_start_date"></span>
              </div>
            </div>

            <div class="d-flex align-items-center mb-9">
              <span class="svg-icon svg-icon-1 svg-icon-danger me-5">
                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                  <circle fill="currentColor" cx="12" cy="12" r="8" />
                </svg>
              </span>

              <div class="fs-6">
                <span class="fw-bolder">Ends</span>
                <span data-kt-calendar="event_end_date"></span>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <span class="svg-icon svg-icon-1 svg-icon-muted me-5">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3" d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z" fill="currentColor"/>
                  <path d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z" fill="currentColor"/>
                </svg>
              </span>

              <div class="fs-6" data-kt-calendar="event_location">
             </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios';  
import Swal from 'sweetalert2';
import i18n from '@/i18n';

axios.interceptors.response.use((response) => {
  if (response.data.error) {
    const cleanedErrorMessage = response.data.error.replace(/\s?\(.*?\)$/, '').trim();
    const key = `dbErrors.${cleanedErrorMessage}`;
    const translated = i18n.global.te(key) ? i18n.global.t(key) : cleanedErrorMessage;

    Swal.fire({
        icon: 'error',
        title: i18n.global.t('error'),
        text: translated,
        confirmButtonText: i18n.global.t('OK')
    });

    const sessionId = sessionStorage.getItem('sid');
    const errorMessage = response.data.error;

    if (sessionId && errorMessage) {
      if (errorMessage.includes('ERR_SESSION_NOT_FOUND') || errorMessage.includes('UA-PWC')) {
        let timerInterval;
        Swal.fire({
          title: errorMessage.includes('UA-PWC')
            ? 'The password has been changed successfully.'
            : 'Session terminated!',
          html: errorMessage.includes('UA-PWC')
            ? 'Session terminated! </br> You will be automatically signed out in <b></b> seconds. You must log in to the system again to continue.'
            : 'Session terminated due to some reasons. You will be automatically signed out in <b></b> seconds. Please log in to the system to continue.<div><b>Some of these reasons may be;</b> </br> <i class="bi bi-dot"></i>Changes in user credentials. </br> <i class="bi bi-dot"></i>Updates/upgrades in licence or company information. </br> <i class="bi bi-dot"></i>Starting a different session with the same information.</div>',
          icon: errorMessage.includes('UA-PWC') ? 'success' : 'warning',
          showCancelButton: false,
          showConfirmButton: false,
          allowOutsideClick: false,
          timer: 10000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading();
            const b = Swal.getHtmlContainer().querySelector('b');
            b.textContent = 10;
            timerInterval = setInterval(() => {
              b.textContent = (Swal.getTimerLeft() / 1000).toFixed(0);
            }, 1000);
          },
          willClose: () => {
            clearInterval(timerInterval);
            sessionStorage.clear();
            window.location.href = "/Login";
          }
        });
      }
    }
  }
  return response;
}, 
(error) => {
  return Promise.reject(error.message);
});

export default {
  name: 'Home',
  props: {msg: String},
  data() {
    return {
      searchbar: '',
      isExpanded: false,
      userData: this.$getUser(),
      accountList: [],
      form: {
        companySelection: null,
        companySelectionPre: null,
      },
      selectedCompany: null
    };
  },
  computed: {
    searchableList() {
      return this.accountList.filter(p => { 
        return p.text.toLowerCase().indexOf(this.searchbar.toLowerCase()) != -1 && p.id !== this.userData.id;
      });
    },

  },
  methods: {
    getData() {
      this.accountList = [];
      if (this.$getUser().permission_type == 1 && this.$getUser().account_type == 1) {
        const parameters = {
          session_id: this.$getUser().session_id
        };  
        axios.post('/api/Accounts/ControllerAccount', parameters, {'Content-Type': 'application/json'})
        .then((response) => {
          if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
            this.accountList= response.data;
            this.accountList.forEach(element => {
              element.company_name = this.$unlock(element.company_name);
              element.text = this.$unlock(element.text);
              element.company_vkn = this.$unlock(element.company_vkn);
              element.primary_person = this.$unlock(element.primary_person);
              element.company_gsm = this.$unlock(element.company_gsm);
              element.company_landphone = this.$unlock(element.company_landphone);
              element.company_email = this.$unlock(element.company_email);
              element.company_address = this.$unlock(element.company_address);
              element.company_city = this.$unlock(element.company_city);
              element.company_town = this.$unlock(element.company_town);
              element.company_state = this.$unlock(element.company_state);
              element.company_region = this.$unlock(element.company_region);
              element.company_postcode = this.$unlock(element.company_postcode);
              element.company_country_code = this.$unlock(element.company_country_code);
              element.currency_code = this.$unlock(element.currency_code);
              element.phone_country_code = this.$unlock(element.phone_country_code);
            });
          }
        })
        .catch(function (error) {
          console.error(error);
        });
      } else {
        const parameters = {
          session_id: this.$getUser().session_id,
          controller_id: this.$getUser().controller_account_id
        };  
        axios.post('/api/Accounts/CompanyAccounts', parameters, {'Content-Type': 'application/json'})
        .then((response) => {
          if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
            this.accountList= response.data;
            this.accountList.forEach(element => {
              element.company_name = this.$unlock(element.company_name);
              element.text = this.$unlock(element.text);
              element.company_vkn = this.$unlock(element.company_vkn);
              element.primary_person = this.$unlock(element.primary_person);
              element.company_gsm = this.$unlock(element.company_gsm);
              element.company_landphone = this.$unlock(element.company_landphone);
              element.company_email = this.$unlock(element.company_email);
              element.company_address = this.$unlock(element.company_address);
              element.company_city = this.$unlock(element.company_city);
              element.company_town = this.$unlock(element.company_town);
              element.company_state = this.$unlock(element.company_state);
              element.company_region = this.$unlock(element.company_region);
              element.company_postcode = this.$unlock(element.company_postcode);
              element.company_country_code = this.$unlock(element.company_country_code);
              element.controller_id = this.$unlock(element.controller_id);
              element.controller_account_name = this.$unlock(element.controller_account_name);
              element.system_access_name = this.$unlock(element.system_access_name);
              element.controller_access_name = this.$unlock(element.controller_access_name);
            });
          }
        })
        .catch(function (error) {
          console.error(error);
        });
      }



    },
    onSelectCompany(item) {      
      const params = {
        session_id: this.$getUser().session_id,
        company_id: item.id
      }
      axios.post("/api/CompanyManagement/SetCompanyToSession", params, {'Content-Type': 'application/json'})
      .then((response) => {
        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
          item.activeYear = response.data.company_active_period_id;
          item.localCurrency = response.data.currency_code;
          item.list_date_range = response.data.list_date_range;
          item.currency_search_type = response.data.currency_search_type;
          this.selectedCompany = item;
          window.document.title = item.text + ' | CreatorCUBE';
          this.$setSessionStorage("selected_company", item);
          this.$router.push({ name: 'CompanyOverview' });
          this.emitter.emit('SelectCompany', item);
        }
      })
      .catch(function (error) {
        console.error(error); 
      });
    },
    onInstantLogin(item){
      const parameters = { 
        session_id: this.$getUser().session_id,
        company_id: item.id
      }; 
      axios.post('/api/Users/GetInstantAccessToken', parameters, {'Content-Type': 'application/json'})
      .then((response) => {
          window.open(this.$getUser().company_url + '/?s=' + response.data, '_blank');
      }) 
      .catch(function (error) {
          console.error(error);
          this.Progress.finish();
      });
    } 
  },
  created() { 
    this.getData();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
} 
</style>
